export const PeopleSection = {
  flow: 'y',
  padding: 'A B',
  gap: 'Z1',
  flex: '1',
  minHeight: '0',
  overflow: 'auto'
}
